import { createStyles } from '@mantine/core';

export const useStyles = createStyles(() => ({
  modalWrapper: {
    '& .mantine-Drawer-drawer': {
      height: '50%',
      maxHeight: '400px',
      backgroundColor: '#0C0C0C',
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderRadius: 0,
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
  modalTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    textAlign: 'center',
    justifyContent: 'center',
    gap: '9px',
    marginBottom: '30px',
  },
  modalHeader: {
    fontWeight: 500,
    fontSize: '24px',
    lineHeight: '31px',
    textAlign: 'center',
    color: '#FFFFFF',
  },
  modalDescription: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '21px',
    textAlign: 'center',
    color: '#BFBFBF',
  },
  modalBtnContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '0px 24px',
    gap: '8px',
  },
  modalBtn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '12px 16px',
    gap: '10px',
    color: '#000000',
    borderRadius: '24px',
    fontSize: '14px',
    fontWeight: 500,
    border: 'none',
    background: '#ffffff',
    outline: 'none',
  },
  modalBtnSec: {
    color: '#ffffff',
    background: '#ffffff1A',
  },
  modalSubtext: {
    fontSize: '12px',
    fontWeight: 700,
    lineHeight: '16px',
  },
  gradModal: {
    '& .mantine-Drawer-drawer': {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      textAlign: 'center',
      color: '#ffffff',
      background: 'linear-gradient(270deg, rgba(86, 135, 230, 0.8) 0%, rgba(100, 65, 237, 0.8) 120.05%)',
      backdropFilter: 'blur(34px)',
      padding: '20px',
      paddingTop: '50px',
    },
    '& h2, p': {
      width: '90%',
      margin: 'auto',
    },
  },
}));

export default useStyles;
